import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ATag from './ATag';

const EditIconBtn = props => {
  const { to } = props;
  return (
    <>
      {to === undefined || to === '' ? (
        <ATag onClick={props.onClick} {...props}>
          <FontAwesomeIcon
            icon={['fas', 'pen']}
            className={`icon-edit-pencil ${
              props.className ? props.className : ''
            }`}
          />
          {props.children || ''}
        </ATag>
      ) : (
        <Link {...props}>
          <FontAwesomeIcon
            icon={['fas', 'pen']}
            className={`icon-edit-pencil ${
              props.className ? props.className : ''
            }`}
          />
        </Link>
      )}
    </>
  );
};

export default EditIconBtn;
